declare const Buffer;
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
// import { createPresignedURL } from "./helpers/aws-signature-v4"; // to generate our pre-signed URL
// import * as marshaller from "@aws-sdk/eventstream-marshaller"; // for converting binary event stream messages to and from JSON
// import * as util_utf8_node from "@aws-sdk/util-utf8-node"; // utilities for encoding and decoding UTF8
import MicrophoneStream from "microphone-stream";
import {
  CountdownComponent,
  CountdownConfig,
  CountdownEvent,
} from "ngx-countdown";
import { DomSanitizer } from "@angular/platform-browser";
import { AudioRecordingService } from "@app/core/services/audio-recording.service";
import { EvaluateQuestionService } from "@app/core/http/evaluate-question.service";
import { Subscription } from "rxjs";

@Component({
  selector: "transcribe-deepgram",
  templateUrl: "./deepgram-recorder.component.html",
  styleUrls: ["./deepgram-recorder.component.css"],
})
export class DeepGramComponent implements OnInit, OnDestroy {
  @ViewChild("countdown", { static: false })
  private countdown: CountdownComponent;
  public blobUrl: any;
  isRecording = false;
  public status: any;
  public isClick: boolean = false;
  public anni: String;
  value = 0;
  public interval: any;

  public config: CountdownConfig = {
    leftTime: 0,
    format: "ss",
  };
  public interval1: any;
  public resultScore: any;
  private _subscribe: Subscription;
  private _recordedSubscribe: Subscription;

  languageCode = "en-US";
  region = "us-east-1";
  sampleRate = 44100;
  transcription = "";
  // socket;
  micStream;
  // socketError = false;
  transcribeException = false;
  errorText: "";

  public isCountDown: boolean = true;
  public items: any = [];

  @Input() evaluateObj: any;
  @Output() emitFile: any = new EventEmitter<any>();

  resultData: any = {};

  public audioFile: File;

  constructor(
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer,
    private _service: EvaluateQuestionService
  ) {
    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isRecording = false;
    });

    // this.audioRecordingService.getRecordedTime().subscribe((time) => {
    //   this.recordedTime = time;
    // });
    this._recordedSubscribe = this.audioRecordingService
      .getRecordedBlob()
      .subscribe((data) => {
        this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(data.blob)
        );
        const file = new File([data.blob], this.evaluateObj.questionId);
        this.audioFile = file;

        this.transcribeContinue(data.blob);
      });
  }

  ngOnInit() {
    this.config.leftTime = this.evaluateObj.duration;
    this.isCountDown = true;
    setTimeout(() => {
      this.getCountDown();
    }, 100);
  }

  getCountDown() {
    let countdown = this.evaluateObj.duration;

    this.anni =
      "countdown " + (parseInt(countdown) + 1) + "s linear infinite forwards";
  }

  startRecording() {
    if (this.isMobile()) {
      document.getElementById("my-start-button").onclick = () => {
        this.isShowDialog = false;
        this.startAudioRecording();
        setTimeout(() => {
          this.decrease();
        }, 100);

        navigator.mediaDevices
          .getUserMedia({
            video: false,
            audio: true,
          })
          // ...then we convert the mic stream to binary event stream messages when the promise resolves
          .then(this.streamAudioToWebSocket)
          .catch(function (error) {
            console.log(
              "There was an error streaming your audio to DeepGram. Please try again.",
              error
            );
          });
      };
    } else {
      navigator.mediaDevices
        .getUserMedia({
          video: false,
          audio: true,
        })
        // ...then we convert the mic stream to binary event stream messages when the promise resolves
        .then(this.streamAudioToWebSocket)
        .catch(function (error) {
          console.log(
            "There was an error streaming your audio to DeepGram. Please try again.",
            error
          );
        });
    }
  }
  streamAudioToWebSocket = (userMediaStream) => {
    console.warn("here streamAudioToWebSocket");

    //let's get the mic input from the browser, via the microphone-stream module
    this.micStream = new MicrophoneStream();
    this.micStream.setStream(userMediaStream);

    this.micStream.on("data", (rawAudioChunk) => {
      var base64EncodedStr = btoa(unescape(encodeURIComponent(rawAudioChunk)));
      this.convertBase64toBlob(base64EncodedStr);
    });
  };

  getAudioEventMessage = (buffer) => {
    // wrap the audio data in a JSON envelope
    return {
      headers: {
        ":message-type": {
          type: "string",
          value: "event",
        },
        ":event-type": {
          type: "string",
          value: "AudioEvent",
        },
      },
      body: buffer,
    };
  };

  closeSocket = () => {
    this.stopRecording();

    if (this.micStream) {
      this.micStream.stop();
      this.isClick = true;
    }
  };

  handleEventStreamMessage = (messageJson) => {
    let results = messageJson.Transcript.Results;
    if (results.length > 0) {
      if (results[0].Alternatives.length > 0) {
        let transcript = results[0].Alternatives[0].Transcript;

        // fix encoding for accented characters
        transcript = decodeURIComponent(escape(transcript));

        // update the textarea with the latest result
        console.error("transcript", transcript);
        console.error(results);
        // if this transcript segment is final, add it to the overall transcription
        if (!results[0].IsPartial) {
          if (this.isClick) {
            console.warn("here stop");
            this.items = results;
          }
          //scroll the textarea down
          this.transcription += transcript + "\n";
        }
      }
    }
  };
  public isRealClose: boolean = false;

  handleEvent(e: CountdownEvent) {
    if (e.action === "done") this.timmerEnd(false);
  }

  public isShowDialog: boolean = false;
  timmerEnd(e: boolean) {
    this.countdown.stop();
    this.isCountDown = e;
    if (this.status != "started") {
      this.status = "start";
      setTimeout(() => {
        if (
          this.evaluateObj.questionType != "S002" &&
          this.evaluateObj.questionType != "S005"
        )
          this.playAudioBeep();
        else {
          this.checkDevice();
        }
      });
    }
    clearInterval(this.interval1);
  }

  checkDevice() {
    if (!this.isMobile()) {
      this.startRecording();
      this.startAudioRecording();
      setTimeout(() => {
        this.decrease();
      }, 100);
    } else {
      this.isShowDialog = true;
      setTimeout(() => {
        this.startRecording();
      }, 200);
    }
  }
  playAudioBeep() {
    this.checkDevice();
    let audio = new Audio();
    audio.src = "assets/audio/SpeakingBeep.wav";
    audio.load();
    audio.play();
  }

  decrease() {
    this.status = "started";
    if (this.value == 0) {
      this.value = 1;
      var elem = document.getElementById("myBar");
      var width = 1;
      this.interval = setInterval(() => {
        if (width >= 100) {
          clearInterval(this.interval);
          this.value = 0;
          // this.isClick=true;
          this.onEnd();
        } else {
          width++;
          elem.style.width = width + "%";
        }
      }, this.evaluateObj.recordDuration * 10);
    }
  }

  convertBase64toBlob(b64: string) {
    const byteCharacters = atob(b64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "audio/mp3" });
    this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
      URL.createObjectURL(blob)
    );
    this.audioFile = new File([blob], this.evaluateObj.questionId);
  }

  onRestart() {
    clearInterval(this.interval1);
    clearInterval(this.interval);
    // if (this.socket)
    this.closeSocket();
    this.isCountDown = true;
    this.status = undefined;
    this.anni = undefined;
    setTimeout(() => {
      this.getCountDown();
    }, 100);
  }

  onEnd() {
    clearInterval(this.interval1);
    clearInterval(this.interval);
    if (!this.isClick) {
      this.closeSocket();
    }
    // this.closeSocket();

    // this.stopRecording();
    this.isCountDown = undefined;
    this.status = undefined;
    this.anni = undefined;
  }

  // start here recording
  startAudioRecording() {
    if (!this.isRecording) {
      this.isRecording = true;
      this.audioRecordingService.startRecording();
    }
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    if (this.isRecording) {
      this.audioRecordingService.stopRecording(this.evaluateObj.questionId);
      this.isRecording = false;
    }
  }

  transcribeContinue(blob: Blob) {
    this._subscribe = this._service
      .onManageDeepGram({ blob: blob })
      .subscribe((res) => {
        console.warn("response deepgram", res);
        this.resultScore = res;
        // let deepgram = new JackDeepGram(blob, "nova-filler-words");
        // let result = await deepgram.transcribe();

        let result = res;
        if (result != null) {
          var words: [] = result.results.channels[0].alternatives[0].words;

          this.resultData.transcript =
            result.results.channels[0].alternatives[0].transcript;
          this.resultData.items = [
            {
              Alternatives: [
                {
                  Items: result.results.channels[0].alternatives[0].words.map(
                    (e) => {
                      return {
                        Confidence: e.confidence,
                        Content: e.word,
                        EndTime: e.end,
                        StartTime: e.start,
                      };
                    }
                  ),
                  Transcript:
                    result.results.channels[0].alternatives[0].transcript,
                },
              ],
              ChannelId: result.metadata.channels,
              EndTime:
                words.length != 0
                  ? result.results.channels[0].alternatives[0].words[
                      words.length - 1
                    ].end
                  : 0.0,
              IsPartial: false,
              ResultId: result.metadata.request_id,
              StartTime:
                words.length != 0
                  ? result.results.channels[0].alternatives[0].words[0].start
                  : 0.0,
            },
          ];
          this.resultData.isNoEvaluate = false;
          this.resultData.isTimmer = this.isCountDown;
          this.resultData.recoderStatus = "end";
          this.resultData.blobUrl = this.blobUrl;
          this.resultData.file = this.audioFile;
          console.warn("emitting file", this.resultData);
          this.emitFile.emit(this.resultData);
        }
      });
  }

  clearRecordedData() {
    this.blobUrl = null;
  }
  // end here recording
  isMobile() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  }
  ngOnDestroy(): void {
    // if (this.socket)
    this.closeSocket();
    this.stopRecording();
    if (this._subscribe) this._subscribe.unsubscribe();
    if (this._recordedSubscribe) this._recordedSubscribe.unsubscribe();
    console.warn("destroied subscribe");
  }
}
